import React, {createContext, useContext, useState} from 'react';
import DashboardService from "../services/DashboardService";

import {NotificationContext} from "./NotificationContextProvider";

export const DashboardContext = createContext("DashboardContext");


const DashboardContextProvider = ({children}) => {

    const notificationContext = useContext(NotificationContext);

    const [loading, setLoading] = useState(false);

    const [activePharmacies, setActivePharmacies] = useState([]);
    const [activePharmacyCount, setActivePharmacyCount] = useState(0);
    const [totalCustomersCount, setTotalCustomersCount] = useState(0);
    const [pendingOrders, setPendingOrders] = useState(0);
    const [activeDeliveryPersons, setActiveDeliveryPersons] = useState(0);

    async function getAllNotifications(page, size) {

        return notificationContext.getAllNotifications(page, size);

    }

    async function getAllActivePharmacies(page, size) {

        try {
            setLoading(true);
            const res = await DashboardService.getAllActivePharmacies(page, size);
            setActivePharmacies(res.data)
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            console.log("error", console.error())
            return false;
        }

    }

    async function getActivePharmacyCount() {

        try {
            setLoading(true);
            const res = await DashboardService.getActivePharmacyCount();
            setActivePharmacyCount(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            console.log("error", console.error)
            return false;
        }

    }

    const getAllCustomerCount = async () => {

        try {
            setLoading(true);
            const res = await DashboardService.getAllCustomerCount();
            setTotalCustomersCount(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            console.log("error", console.error);
            return false;
        }

    }

    const getAllPendingOrdersCount = async () => {
        try {
            setLoading(true);
            const res = await DashboardService.getAllPendingOrdersCount();
            setPendingOrders(res.data);
            return res.data;
        } catch (e) {
            setLoading(false);
            return 0;
        }
    }

    const getAllActiveDeliveryPersonCount = async () => {
        try {
            setLoading(true);
            const res = await DashboardService.getAllActiveDeliveryPersonCount();
            setActiveDeliveryPersons(res.data);
            return res.data;
        } catch (e) {
            setLoading(false);
            return 0;
        }
    }

    return (
        <DashboardContext.Provider
            value={{
                loading,
                activePharmacies,
                activePharmacyCount,
                totalCustomersCount,
                pendingOrders,
                activeDeliveryPersons,
                getAllActivePharmacies,
                getActivePharmacyCount,
                getAllNotifications,
                getAllCustomerCount,
                getAllPendingOrdersCount,
                getAllActiveDeliveryPersonCount
            }}
        >
            {children}
        </DashboardContext.Provider>
    );
}

export default DashboardContextProvider;
